<template>
    <div class="task-center-container">
        <div
            v-if="taskList.length"
            ref="taskTarget"
            :class="['task-entry-box', taskDesc ? 'has-desc' : 'no-desc']"
            @mouseenter="taskEnter"
            @mouseleave="taskLeave"
        >
            <div
                :class="['icon', taskDesc ? 'new' : '']"
            ></div>
            <div
                v-if="taskDesc"
                class="entry-title"
            >{{ taskDesc }}</div>
        </div>
        <!-- 任务中心弹窗 -->
        <veui-popover
            v-if="taskList.length"
            :open.sync="openTaskModal"
            overlay-class="task-center-tooltip"
            target="taskTarget"
            position="top-end"
            trigger="hover-click"
            :aim-center="false"
        >
            <div
                class="task-center-box"
                @mouseenter="contentEnter"
                @mouseleave="contentLeave"
            >
                <div
                    v-for="item, index in taskList"
                    :key="index"
                    class="task-item-box"
                >
                    <div class="task-name-box">
                        <div class="task-name">{{ item.name }}</div>
                        <div class="task-progress">
                            <span>{{ item.hasFinishedCount }}</span>/<span>{{ item.option_list.length }}</span>
                        </div>
                    </div>
                    <div
                        v-for="taskItem, innerindex in item.option_list"
                        :key="innerindex"
                        class="task-info-box"
                    >
                        <div class="left-content">
                            <div class="task-title">
                                <div
                                    v-if="taskItem.icon"
                                    class="icon"
                                    :style="{backgroundImage: `url(${taskItem.icon})`}"
                                ></div>
                                <div class="title">{{ taskItem.name }}</div>
                                <template v-if="taskItem.tip">
                                    <img
                                        :ref="'option-tips' + taskItem.task_option_id"
                                        class="tips-icon"
                                        src="https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/tips-icon-grey.png"
                                        alt=""
                                    />
                                    <veui-popover
                                        :target="'option-tips' + taskItem.task_option_id"
                                        position="top"
                                    >
                                        <span
                                            class="help-text"
                                            @mouseenter="contentEnter"
                                            @mouseleave="contentLeave"
                                        >
                                            {{ taskItem.tip }}
                                        </span>
                                    </veui-popover>
                                </template>
                            </div>
                            <div class="task-subtitle">{{ taskItem.description }}</div>
                        </div>
                        <div class="right-content">
                            <div
                                :class="[
                                    'finished-btn',
                                    +taskItem.complete_status < 2 ? 'go-finish' : 'has-finished',
                                ]"
                                @click="goComplete(item, taskItem)"
                            >
                                {{ receiveBtnInfo[taskItem.complete_status] }}
                            </div>
                        </div>
                    </div>
                    <!-- 奖励领取模块 -->
                    <div
                        :ref="'equity-' + item.reward"
                        class="task-reward-box"
                        @mouseenter="rewardEnter(item)"
                    >
                        <div class="reward-left-box">
                            <div class="reward-desc">{{ item.description }}</div>
                            <template v-if="item.tip">
                                <img
                                    :ref="'task-tips' + item.task_template_id"
                                    class="tips-icon"
                                    src="https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/tips-icon-gold.png"
                                    alt=""
                                    @mouseenter="rewardTipsEnter(item)"
                                />
                                <veui-popover
                                    :target="'task-tips' + item.task_template_id"
                                    :hide-delay="50"
                                    position="top"
                                >
                                    <span
                                        class="help-text"
                                        @mouseenter="contentEnter"
                                        @mouseleave="contentLeave"
                                    >
                                        {{ item.tip }}
                                    </span>
                                </veui-popover>
                            </template>
                        </div>
                        <div
                            :class="{
                                'reward-btn': true,
                                'disabled': item.status !== 2 || (item.reward === 'trialVip' && vipInfo.validityStart),
                            }"
                            @click="onReceivedBtnClick(item, index)"
                        >
                            {{ curLoading === null
                                ? +item.status !== 3 ? '领取奖励' : '已领取'
                                : ''
                            }}
                            <veui-loading
                                :loading="curLoading === index"
                                class="loading"
                                ui="normal s"
                            >
                                领取中
                            </veui-loading>
                        </div>
                    </div>
                    <!-- 权益说明弹窗 -->
                    <veui-popover
                        v-if="item.reward_pic"
                        position="bottom-end"
                        :target="'equity-' + item.reward"
                        :overlay-class="[item.reward + '-tooltip', 'reward-tooltip']"
                        :hide-delay="50"
                    >
                        <img
                            class="privilege-detail"
                            :src="item.reward_pic"
                            @mouseenter="contentEnter"
                            @mouseleave="contentLeave"
                        />
                    </veui-popover>
                </div>
            </div>
        </veui-popover>
        <!-- 领取成功弹窗 -->
        <veui-dialog
            :open="dialogOpen"
            :footless="true"
            :closable="false"
            ui="auto"
            overlay-class="accepet-success-dialog"
        >
            <div class="accepet-success-box">
                <div class="icon"></div>
                <div class="content">
                    {{ dialogInfo.title }}
                </div>
                <div
                    class="confirm-btn"
                    @click="onDialogClose"
                >我知道了</div>
            </div>
        </veui-dialog>
        <!-- 微信服务号弹窗 -->
        <wechat-service-dialog
            :show="isShowWechatServiceDialog"
            @close="() => isShowWechatServiceDialog = false"
        ></wechat-service-dialog>
    </div>
</template>

<script>
/**
 * @file 律师任务中心
 */

import {mapState, mapMutations} from 'vuex';
import {Popover, Dialog, Loading} from 'veui';
import wechatServiceDialog from './wechat-service-dialog.vue';
import dayjs from 'dayjs';

const URL = {
    // 领取奖励
    claimtaskreward: '/bp/api/task/claimtaskreward',
    // 领取任务
    claimtask: '/bp/api/task/claimtask',
    // 任务列表
    getTaskList: '/bp/api/task/list'
};

export default {
    name: 'task-center-com',
    components: {
        'veui-popover': Popover,
        'veui-dialog': Dialog,
        'veui-loading': Loading,
        'wechat-service-dialog': wechatServiceDialog
    },
    computed: {
        ...mapState({
            userInfoNew: state => state?.lawStore?.userInfoNew,
            vipInfo: state => state.lawStore.vipInfo || {}
        })
    },
    watch: {
        userInfoNew(val) {
            // 律师场景
            if (val && +val.user_role === 0) {
                this.getTaskList();
            }
        }
    },
    created() {
    },
    data() {
        return {
            // 生成用户-lvlin公众平台二维码
            userwechatQrcode: '',
            receiveBtnInfo: {
                // 未领取
                0: '去领取',
                //  已领取未完成
                1: '去完成',
                // 已完成未领取奖励
                2: '已完成',
                // 已完成已领取奖励
                3: '已完成'
            },
            // 任务列表
            taskList: [],
            curTaskInfo: {},
            // 任务描述
            taskDesc: '',
            openTaskModal: false,
            dialogOpen: false,
            dialogInfo: {},
            isInit: false,
            isShowWechatServiceDialog: false,
            curLoading: null
        };
    },
    methods: {
        ...mapMutations({
            setGuideType: 'lawStore/setGuideType'
        }),

        /**
         * 任务中心滑入
         */

        taskEnter() {
            this.contentEnter();
            this.getTaskList();
            this.openTaskModal = true;
            this.$wywLog.send({
                serverId: 17629,
                area: 'taskcenter',
                action: 'show'
            });
        },
        /**
         * 任务中心滑出
         */

        taskLeave() {
            this.hideTimer = setTimeout(() => {
                this.openTaskModal = false;
                this.hideTimer = null;
            }, 300);
        },

        contentEnter() {
            this.hideTimer && clearTimeout(this.hideTimer);
        },

        contentLeave() {
            this.taskLeave();
        },

        /**
         * 获取任务列表
         */

        getTaskList() {
            this.$http
                .get(URL.getTaskList, {
                }).then(res => {
                    if (+res.code !== 0) {
                        return;
                    }
                    this.taskList = res.data || [];
                    let hasNotAcceptTask = false;
                    let promiseList = [];
                    // 已完成的任务
                    let taskFinishDescInfo = {};
                    // 未完成的任务
                    let taskNotFinishDescInfo = {};
                    this.taskList.forEach(item => {
                        item.hasFinishedCount = 0;
                        let {task_template_id, status, auto_claim} = item;
                        // 主任务未领取,且需要自动领取
                        if (+status === 0 && auto_claim) {
                            hasNotAcceptTask = true;
                            promiseList.push(this.onClaimTask(task_template_id));
                        }
                        // 外层入口，文案信息
                        if (+item.index >= 0 && item.description) {
                            // 任务未完成
                            if (status < 2) {
                                taskNotFinishDescInfo[item.index] = item.description;
                            }
                            // 任务已完成奖励未领取
                            else if (status === 2) {
                                taskFinishDescInfo[item.index] = item.description;
                            }
                        }

                        item.option_list && item.option_list.forEach(taskItem => {
                            // complete_status 0 未完成 2 已完成未领取奖励 3 已完成已领取奖励
                            if (+taskItem.complete_status === 2 || +taskItem.complete_status === 3) {
                                item.hasFinishedCount++;
                            }
                            // 子任务按钮曝光
                            this.openTaskModal && this.$wywLog.send({
                                serverId: 17629,
                                area: 'task-btn',
                                action: 'show',
                                templateid: item.task_template_id,
                                taskid: taskItem.task_option_id,
                                status: +taskItem.complete_status === 2 || +taskItem.complete_status === 3 ? '11' : '00'
                            });
                        });

                        // 奖励按钮曝光
                        this.openTaskModal && this.$wywLog.send({
                            serverId: 17629,
                            area: 'reward-btn',
                            action: 'show',
                            reward: item.reward,
                            templateid: item.task_template_id,
                            status: '' + `${item.status}${item.status}${item.status}`
                        });
                    });
                    // 外层入口文案信息展示-根据优先级取,index值越小，权重越高
                    let finishKeys = Object.keys(taskFinishDescInfo);
                    let notfinishKeys = Object.keys(taskNotFinishDescInfo);
                    let finishNum = Math.min.apply(null, finishKeys);
                    let notfinishNum = Math.min.apply(null, notfinishKeys);
                    let taskDesc = taskNotFinishDescInfo[notfinishNum] || taskFinishDescInfo[finishNum] || '';
                    // if (taskDesc && taskDesc.length > 16) {
                    //     taskDesc = taskDesc.slice(0, 16) + '...';
                    // }
                    this.taskDesc = taskDesc;
                    // 提示态-每日首次自动弹出
                    if (this.taskDesc) {
                        let date = dayjs(new Date()).format('YYYYMMDD');
                        let showTime = localStorage.getItem('taskCenterModalShow');
                        if (date && showTime !== date) {
                            this.openTaskModal = true;
                            localStorage.setItem('taskCenterModalShow', date);
                            // 任务弹窗曝光
                            this.$wywLog.send({
                                serverId: 17629,
                                area: 'taskcenter',
                                action: 'show'
                            });
                        }
                    }
                    // 入口曝光
                    if (!this.isInit) {
                        this.isInit = true;
                        this.$wywLog.send({
                            serverId: 17629,
                            area: 'taskcenter-btn',
                            action: 'show',
                            status: this.taskDesc ? 1 : 0
                        });
                    }
                    // 自动领取后-重新刷新任务列表
                    if (hasNotAcceptTask) {
                        Promise.all(promiseList).then(() => {
                            setTimeout(() => {
                                this.getTaskList();
                            }, 200);
                        }).catch(err => {
                        });
                    }
                }).catch(err => {
                });
        },

        /**
         * 更新任务描述
         * @param {object} info 任务信息
         */
        updateTaskDesc(info) {
            this.taskInfo = info;
        },

        /**
         * 去完成
         * @param {object} temItem 主任务信息
         * @param {object} item 子任务信息
         */

        goComplete(temItem = {}, item = {}) {
            // 子任务按钮曝光
            this.$wywLog.send({
                serverId: 17629,
                area: 'task-btn',
                action: 'click',
                templateid: temItem.task_template_id,
                taskid: item.task_option_id,
                status: +item.complete_status === 2 || +item.complete_status === 3 ? '11' : '00'
            });
            // 已完成
            if (+item.complete_status >= 2) {
                return;
            }
            let actionMap = {
                // 个人信息审核
                personalAudit: '/material?fr=rwzx',
                // 上传案例
                uploadCase: '/caseManage?fr=rwzx',
                // 热搜问题
                uploadQaContent: '/hotQuestion?fr=rwzx'
            };
            let {action} = item;
            // 微信绑定
            if (action === 'bindWechat') {
                this.isShowWechatServiceDialog = true;
                this.openTaskModal = false;
                // this.setGuideType(1);
                return;
            }
            let link = actionMap[action];
            if (!link) {
                return;
            }
            if (link.indexOf('http') > -1 || link.indexOf('https') > -1) {
                this.openTaskModal = false;
                window.open(link);
                return;
            }
            this.openTaskModal = false;
            this.$router.push({
                path: link
            });
        },

        /**
         * 领取任务
         * @param {number} id 任务模板id
         */

        onClaimTask(id) {
            return new Promise((resolve, reject) => {
                if (!id) {
                    resolve();
                    return;
                }
                this.$http
                    .post(URL.claimtask, {
                        task_template_id: id
                    }).then(res => {
                        resolve();
                    }).catch(err => {
                        reject();
                    });
            });
        },

        /**
         * 领取奖励
         * @param {object} item
         */

        onReceivedBtnClick(item, index) {
            this.curTaskInfo = item;
            // 0-未领取 1-已领取任务未完成 2-待领取奖励 3-已领取奖励
            let toastInfo = {
                0: '未领取该任务',
                1: '完成任务即可领取奖励',
                3: '已领取过该奖励'
            };
            // 奖励按钮点击
            this.$wywLog.send({
                serverId: 17629,
                area: 'reward-btn',
                action: 'click',
                reward: item.reward,
                templateid: item.task_template_id,
                status: '' + `${item.status}${item.status}${item.status}`
            });
            // 已开通会员，免体奖励不可领取
            if (item.reward === 'trialVip' && this.vipInfo.validityStart) {
                this.toast({
                    info: '您已领取或开通过会员，该奖励已失效',
                    type: 'info'
                });
                return;
            }
            if (+item.status !== 2) {
                this.toast({
                    info: toastInfo[item.status] || '不满足领取条件',
                    type: 'info'
                });
                return;
            }
            this.curLoading = index;
            this.$http
                .post(URL.claimtaskreward, {
                    privilege: item.reward,
                    task_template_id: item.task_template_id
                }).then(res => {
                    this.curLoading = null;
                    if (+res.code !== 0) {
                        this.toast({
                            info: res.msg || '领取失败',
                            type: 'error'
                        });
                        return;
                    }
                    this.dialogInfo = {
                        title: `您已成功领取${item.reward_text}`
                    };
                    this.dialogOpen = true;
                    this.getTaskList();
                    this.$wywLog.send({
                        serverId: 17629,
                        area: 'lgcg',
                        action: 'show',
                        reward: this.curTaskInfo.reward,
                        templateid: this.curTaskInfo.task_template_id
                    });
                }).catch(err => {
                    this.curLoading = null;
                });
        },

        /**
         * toast信息提示
         * @param {string} info 提示信息
         * @param {number} time 弹窗时间
        */

        toast({info, time = 2, type = 'info'}) {
            if (!info) {
                return;
            }
            let toast = {
                content: info,
                duration: time
            };
            this.$Message[type](toast);
        },

        /**
         * 权益领取成功弹窗
         */
        onDialogClose() {
            this.dialogOpen = false;
            this.$wywLog.send({
                serverId: 17629,
                area: 'lqcg-btn',
                action: 'click',
                reward: this.curTaskInfo.reward,
                templateid: this.curTaskInfo.task_template_id
            });
        },

        /**
         * 奖励领取-tips
         * @param {object} item
         */

        rewardTipsEnter(item = {}) {
            this.$wywLog.send({
                serverId: 17629,
                area: 'jlsm-btn',
                action: 'hover',
                reward: item.reward,
                templateid: item.task_template_id,
                status: item.status
            });
        },

        /**
         * 权益展示弹窗
         * @param {object} item
         */

        rewardEnter(item = {}) {
            this.$wywLog.send({
                serverId: 17629,
                area: 'qyzs',
                action: 'show',
                reward: item.reward,
                templateid: item.task_template_id,
                status: item.status
            });
        }
    }
};
</script>

<style lang='less' scoped>
.task-center-container {
    .task-entry-box {
        position: relative;
        cursor: pointer;
        height: 34px;
        display: flex;
        align-items: center;
        margin-right: 32px;

        &.has-desc {
            padding: 0 12px 0 21px;
            border: .5px solid #ffdec3;
            background: #fed9b94d;
            border-radius: 5px;
        }

        .icon {
            position: relative;
            flex-shrink: 0;
            width: 18px;
            height: 18px;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/task-entry-icon.png") no-repeat center;
            background-size: cover;

            &.new::after {
                content: "";
                display: block;
                position: absolute;
                top: -4px;
                right: -4px;
                width: 8px;
                height: 8px;
                background-color: #ff274b;
                border-radius: 50%;
            }
        }

        .entry-title {
            margin-left: 11px;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
        }
    }
}

.task-center-box {
    max-height: 689px;
    padding: 40px;
    overflow-y: auto;
    box-sizing: border-box;

    .line {
        height: 1px;
        background: #84869133;
    }

    .task-item-box {
        &:not(:first-child) {
            margin-top: 20px;
        }

        .task-name-box {
            display: flex;
            align-items: center;
            padding-bottom: 20px;

            .task-name {
                font-family: PingFang SC;
                font-size: 20px;
                line-height: 20px;
                font-weight: 500;
                color: #333;
            }

            .task-progress {
                margin-left: 10px;
                font-family: PingFang SC;
                font-size: 16px;
                line-height: 16px;
                font-weight: 500;
                color: #848691;
            }
        }

        .task-info-box {
            display: flex;
            align-items: center;
            border-top: 1px solid #edeef0;
            padding: 20px 0;

            .left-content {
                flex: 1;

                .task-title {
                    display: flex;
                    align-items: center;

                    .icon {
                        width: 20px;
                        height: 20px;
                        margin-right: 10px;
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: cover;
                    }

                    .title {
                        font-family: PingFang SC;
                        font-size: 16px;
                        line-height: 16px;
                        font-weight: 500;
                    }

                    .tips-icon {
                        width: 12px;
                        height: 12px;
                        margin-left: 4px;
                    }

                    .help-text {
                        font-family: PingFang SC;
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 24px;
                        color: #1e1f24;
                    }
                }

                .task-subtitle {
                    margin-top: 14px;
                    font-family: PingFang SC;
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: 400;
                }
            }

            .right-content {
                flex-shrink: 0;
                padding-left: 12px;
                margin-right: 20px;

                .finished-btn {
                    width: 80px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    font-family: PingFang SC;
                    font-size: 14px;
                    line-height: 1;
                    font-weight: 500;
                    box-sizing: border-box;
                    border-radius: 5px;
                }

                .go-finish {
                    cursor: pointer;
                    text-align: center;
                    border: 1px solid #1763ff;
                    box-sizing: border-box;
                    color: #1763ff;
                }

                .has-finished {
                    color: #848691;
                    cursor: disabled;
                }
            }
        }

        .task-reward-box {
            padding: 20px 20px 20px 30px;
            display: flex;
            align-items: center;
            min-height: 76px;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/reward-bg.png") no-repeat center;
            background-size: cover;
            box-sizing: border-box;
            border-radius: 6px;
            cursor: pointer;

            .reward-left-box {
                flex: 1;
                display: flex;
                align-items: center;

                .reward-desc {
                    font-family: PingFang SC;
                    font-size: 16px;
                    line-height: 24px;
                    font-weight: 500;
                    color: #9c5300;
                }

                .tips-icon {
                    width: 12px;
                    height: 12px;
                    margin-left: 4px;
                }
            }

            .reward-btn {
                position: relative;
                flex-shrink: 0;
                margin-left: 12px;
                width: 80px;
                height: 36px;
                text-align: center;
                font-family: PingFang SC;
                font-size: 14px;
                line-height: 36px;
                font-weight: 500;
                background: #fed9b9;
                color: #401611;
                border-radius: 5px;
                cursor: pointer;

                &.disabled {
                    cursor: disabled;
                    opacity: .4;
                }

                /deep/ .loading {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding-left: 2px;
                    top: 0;
                    left: 0;
                    z-index: 1;
                    border-radius: 5px;
                    box-sizing: border-box;
                }
            }
        }
    }
}

.task-center-tooltip {
    z-index: 200 !important;

    /deep/ .veui-tooltip {
        max-width: 528px !important;
        width: 528px;

        .veui-tooltip-content {
            padding: 0;
            margin: 0;
        }
    }
}

.accepet-success-dialog {
    /deep/ .veui-dialog-content {
        width: 420px;
        padding: 30px;
        box-sizing: border-box;
        background: linear-gradient(180deg, #facba2 -24.21%, #fff 17.37%);

        .veui-dialog-content-head {
            display: none;
        }

        .accepet-success-box {
            position: relative;

            .icon {
                width: 208px;
                height: 140px;
                margin: 0 auto;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/wise-guide/crown-new-icon.png") no-repeat center;
                background-size: cover;
            }

            .content {
                position: relative;
                margin-top: -24px;
                z-index: 2;
                font-family: PingFang SC;
                font-size: 16px;
                font-weight: 500;
                line-height: 26px;
                text-align: center;
                color: #401611;
            }

            .confirm-btn {
                cursor: pointer;
                margin-top: 17px;
                height: 40px;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 500;
                line-height: 40px;
                text-align: center;
                background: #fed9b9;
                color: #401611;
                border-radius: 6px;
            }
        }
    }
}

.privilege-detail {
    width: 100%;
}

/deep/ .veui-tooltip {
    box-shadow: 0 3px 8px 0 #d7dce98c;

    .veui-tooltip-arrow {
        display: none;
    }
}

.reward-tooltip {
    left: -120px !important;
}

.show5865_7day-tooltip {
    /deep/ .veui-tooltip {
        max-width: 564px !important;
        width: 564px;
        height: 341px;
        border-radius: 16px;
        overflow: hidden;

        .veui-tooltip-content {
            padding: 0;
            margin: 0;
        }
    }
}

.trialVip-tooltip {
    /deep/ .veui-tooltip {
        max-width: 718px !important;
        width: 708px;
        height: 440px;
        border-radius: 16px;
        overflow: hidden;

        .veui-tooltip-content {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
